


























import { Component, Vue, Prop } from 'vue-property-decorator';
import { ICollapseInfo } from './collapseBoxUtils';


@Component
export default class CollapseBox extends Vue {
  @Prop({ required: true, default: () => [] }) private collapseData!: ICollapseInfo[];
  @Prop({ default: false }) private spinning!: boolean;
  private activeKey = '';
}
